module.exports = __webpack_public_path__ + "img/drink_coffee.237cb3da.png";